import type { BoardStickerRow, TaskTrackerBoardSticker } from '../store/taskTracker.types'

export const mapReorderedBoardStickerRowsToStickers = (
  stickers: TaskTrackerBoardSticker[],
  reorderedRows: BoardStickerRow[],
): TaskTrackerBoardSticker[] => {
  const stickerByFieldSettingId = new Map(
    stickers.map((sticker) => [sticker.fieldSettingId, sticker]),
  )

  return reorderedRows.map((row) => {
    const sticker = stickerByFieldSettingId.get(row.fieldSettingId)
    if (!sticker) {
      throw new Error('Не удалось обновить порядок стикеров доски')
    }

    return {
      ...sticker,
      position: row.boardPosition,
    }
  })
}

export const hasInvalidBoardStickerPositions = (
  stickers: TaskTrackerBoardSticker[],
): boolean => {
  if (stickers.length <= 1) return false

  const positions = stickers.map((sticker) => sticker.position)
  const zeroCount = positions.filter((position) => position === 0).length

  if (zeroCount > 1) return true
  if (zeroCount > 0 && positions.some((position) => position > 0)) return true

  const uniquePositions = new Set(positions)
  return uniquePositions.size !== positions.length
}

export const preferOptimisticBoardStickerPositions = (
  apiStickers: TaskTrackerBoardSticker[],
  optimisticStickers: TaskTrackerBoardSticker[],
): TaskTrackerBoardSticker[] => {
  const positionByFieldSettingId = new Map(
    optimisticStickers.map((sticker) => [
      sticker.fieldSettingId,
      sticker.position,
    ]),
  )

  return apiStickers.map((sticker) => ({
    ...sticker,
    position:
      positionByFieldSettingId.get(sticker.fieldSettingId) ?? sticker.position,
  }))
}

export const mapBoardStickerToRow = (
  sticker: TaskTrackerBoardSticker,
): BoardStickerRow => ({
  fieldSettingId: sticker.fieldSettingId,
  fieldType: sticker.fieldType,
  title: sticker.title,
  color: sticker.color,
  boardPosition: sticker.position,
  isVisible: sticker.isVisible,
  isRequired: sticker.isRequired,
  catalogIsRequired: sticker.catalogIsRequired,
  isSystem: sticker.isSystem,
  systemKey: sticker.systemKey,
  canEdit: sticker.canEdit,
  canManageRequired: sticker.canManageRequired,
  options: sticker.options ?? [],
})

export const mapAllBoardStickersToBoardStickerRows = (
  stickers: TaskTrackerBoardSticker[],
): BoardStickerRow[] =>
  [...stickers]
    .sort((left, right) => left.position - right.position || left.id - right.id)
    .map(mapBoardStickerToRow)

export const mapBoardStickersToBoardStickerRows = (
  stickers: TaskTrackerBoardSticker[],
): BoardStickerRow[] =>
  mapAllBoardStickersToBoardStickerRows(stickers).filter(
    (sticker) => sticker.isVisible,
  )
